import request from '@/utils/request'

// 获取网站基础信息
export function getBase(languageId) {
  return request({
    url: 'api/public/base/' + languageId,
    method: 'get',
  });
}
// 获取网站栏目
export function getModules(languageId) {
  return request({
    url: 'api/public/modules/' + languageId,
    method: 'get',
  });
}
// 获取验证码
export function getCaptcha() {
  return request({
    url: 'api/public/captcha',
    method: 'get',
  });
}
// 获取STS上传授权
export function getStsInfo(data) {
  return request({
    url: 'api/public/fileSts',
    method: 'post',
    data: data
  });
}




// WEBPACK FOOTER //
// ./src/api/common.js